import ValueTracker from "../prop-trackers/value-tracker.js";
import { ValueMapper } from "../prop-tracker-utils/mapper.js";

class PromiseUnwrapMapper extends ValueMapper {
    constructor() {
        super();

        this._promise = null;
        this._valueTracker = new ValueTracker();

        this._valueTracker.listenNeedsUpdate(() => this.protected_needsUpdate());
    }

    setValue(promise) {
        this._promise = promise || null;

        if (promise) {
            promise.then(value => {
                if (this._promise === promise) {
                    this._valueTracker.setValue(value);
                }
            });
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._valueTracker.deleteValue();
    }

    protected_startUpdate() {
        return this._valueTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._valueTracker.finishUpdate();
    }
}

export default PromiseUnwrapMapper;
